"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionSplitterMiddleware = void 0;
const actionSplitterMiddleware = () => (next) => (action) => {
    if (Array.isArray(action)) {
        action.forEach((_action) => next(_action));
    }
    else {
        next(action);
    }
};
exports.actionSplitterMiddleware = actionSplitterMiddleware;
//# sourceMappingURL=actionSplitter.js.map